module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }